import styled from '@emotion/styled';
import {Des, H1} from '../typography';
import {ReactNode} from "react";

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 14px;
    margin-top: 18px;
`;

interface Props {
    title: string;
    description?: string | ReactNode;
}

export default function Title({title, description}: Props) {
    return (
        <Container>
            <H1>{title}</H1>
            <Des>{description}</Des>
        </Container>
    );
}